import { cn } from '@/lib/utils'

interface AnimatedCheckmarkProps {
  size?: number
  className?: string
}

/**
 * The Peace-state signature: a sage circle with a check that draws itself in,
 * wrapped in a gently breathing halo. Reduced-motion renders fully drawn.
 */
export function AnimatedCheckmark({ size = 80, className }: AnimatedCheckmarkProps) {
  return (
    <div
      className={cn('relative inline-flex items-center justify-center', className)}
      style={{ width: size * 1.18, height: size * 1.18 }}
      role="img"
      aria-label="All is well"
    >
      <span
        className="hearth-halo absolute inset-0 rounded-full bg-success-200/35"
        aria-hidden="true"
      />
      <span
        className="relative flex items-center justify-center rounded-full bg-success-100"
        style={{ width: size, height: size }}
      >
        <svg
          viewBox="0 0 1 1"
          style={{ width: size * 0.5, height: size * 0.5 }}
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M0.12 0.55 L0.40 0.82 L0.88 0.22"
            pathLength="1"
            className="hearth-check stroke-success-600"
            strokeWidth={0.1}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </div>
  )
}
